import { render, staticRenderFns } from "./SliderWithCta.vue?vue&type=template&id=0c09bd5e&scoped=true&name=slider-with-cta&"
import script from "./SliderWithCta.vue?vue&type=script&lang=js&"
export * from "./SliderWithCta.vue?vue&type=script&lang=js&"
import style0 from "./SliderWithCta.vue?vue&type=style&index=0&id=0c09bd5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09bd5e",
  null
  
)

export default component.exports